

































































	import { BaseTLTableComponent, AxiosResponse, Component, AttributeService, AttributeFilter, AttributeValueService, AttributeValueFilter, Prop } from "../../../Infrastructure/CorBase/CoreBase";


	@Component
	export default class AttributesList extends BaseTLTableComponent {
		@Prop({ type: Boolean, required: false, default: false }) isUpdate?: boolean;


		itemsAttribute: any[] = [];

		itemsTypeExist: number[] = []; //které už má
		updateMode: boolean = false;

		labelWidth: string = "1";
		inputWidth: string = "6";


		attributeService: AttributeService = new AttributeService();
		attributeValueService: AttributeValueService = new AttributeValueService();


		notAllowAdd() {
			return this.formData.idAttribute == null || this.formData.value.length == 0;
		}

		notAllowNewAttributeValue() {		
			return this.formData.idAttribute == null || this.formData.value.length == 0 || this.tableData.filter(c => c.idAttribute == this.formData.idAttribute).length > 0 ;
		}

		showCreateButton() {
			return this.tableData.filter(c => c.idAttribute == this.formData.idAttribute).length == 0 && this.formData.idAttribute != 0;
		}

		isNewAttributeValue() {
			return true;
		}

		formData = {
			id: 0,
			idAttribute: 0,
			idObject: 0,
			value: ''
		}


		setFields() {
			this.fields = [
				{ key: 'idAttributeNavigationName', label: 'Název', sortable: true, class: 'text-center' },
				{ key: 'value', label: 'Hodnota', sortable: true, class: 'text-center' },
                { key: 'actions', label: 'Volby', class: 'text-right' }
			]
		};

		//filtry
		setfilters(value: any) {
		}

		createAtributeValue() {

			this.formData.id = 0;
			this.attributeValueService.create(this.formData).then(() => {
			}).then(() => {
				this.fetchData();
				this.goBack();
			}
			).catch((error) => {

			});
		}

		setPersonId(id: number) {
			this.formData.idObject = id;
			this.fetchData();
		}

		created() {
			super.initializeRights('COR_Person_Create', 'COR_Person_Delete', 'COR_Person_Read', 'COR_Person_Update');
			super.created();
			this.formData.idObject = this.objectIdFromParam;
			this.fetchAttribute();
			this.fetchData();
		};

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let attributeValueFilter: AttributeValueFilter = new AttributeValueFilter(this.formData.idObject, this.$store.state.idTenant);
			return this.attributeValueService.getAllByFilter(attributeValueFilter);
		}

        //zatím nepotrebujeme
        fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
            return this.fetchDataFromServer();
        }

        refreshItems(items: any[], refreshData: any[]) {
            return items;
        }

		fetchData() {
			
			if (this.formData.idObject > 0) {
				super.fetchData();
				this.goBack();
			}

		}

		prepareItems(items: any[]) {
		}


		//nacteni vsech monžných attributů
		fetchAttribute() {
			let attributeFilter: AttributeFilter = new AttributeFilter(this.$store.state.idTenant);
			this.attributeService.getAllByFilter(attributeFilter).then((response) => {
				this.itemsAttribute = [];

				for (var i = 0; i < response.data.length; i++) {
					this.itemsAttribute.push({
						value: response.data[i].id,
						text: response.data[i].name
					});
				}
			}).catch((error) => {

			});
		}

		saveAttributeValue() {
			this.formData.value = this.formData.value;
			this.attributeValueService.update(this.formData.id, this.formData).then(() => {
			}).then(() => {
				this.fetchData();
			}
			).catch((error) => {
			})
		}

		goBack() {
			this.updateMode = false;
			this.formData.idAttribute = 0;
			this.formData.value = '';
		}

		startUpdate(id: any) {
			this.formData.id = id;
			this.formData.idAttribute = Number(this.tableData.filter(c => c.id == id)[0].idAttribute);
			this.formData.value = this.tableData.filter(c => c.id == id)[0].value;
			this.updateMode = true;
		}

		deleteAttributeValue(id: any) {
			this.attributeValueService.delete(id).then(() => {
				this.fetchData();
			}).catch((error) => {
			})
		};



	};
